// Build-time site origin. Production = hyperxlevel.com (confirmed 2026-07-07);
// when a staging domain lands (Phase 4), follow the Gamerhood S5 convention:
// source files carry one origin literal and VITE_SITE_URL rewrites everything
// at build time (vite.config.ts siteUrlPlugin).
export const SITE_URL = (import.meta.env.VITE_SITE_URL || 'https://hyperxlevel.com').replace(
  /\/+$/,
  '',
);

export type PageMetaEntry = {
  path: string;
  title: string;
  description: string;
};

export const PAGE_META = {
  home: {
    path: '/',
    title: 'HyperX Level Awakening',
    description:
      'HyperX Level Awakening — live on the HyperX Twitch channel August 20, 2026. Presented by AMD and PC Game Pass.',
  },
  register: {
    // URL is /sweepstakes per client (2026-07-24); the page/component/module
    // names stay "register" — only the public path changed.
    path: '/sweepstakes',
    title: 'Register - HyperX Level Awakening',
    description:
      'Register for the HyperX Level Awakening giveaway and take the survey. Live August 20, 2026.',
  },
  backgrounds: {
    // Unlisted by choice (2026-08-19): no nav or footer link and absent from
    // sitemap.xml, same posture as /sweepstakes — the URL is handed out
    // directly (stream overlay, socials). Reachable and indexable if someone
    // links it; just not advertised by us.
    path: '/backgrounds',
    title: 'Backgrounds - HyperX Level Awakening',
    description:
      'Download the official HyperX Level Awakening wallpapers in 5760 x 3240. Live August 20, 2026.',
  },
  rules: {
    path: '/rules',
    title: 'Official Rules - HyperX Level Awakening',
    description: 'Official rules for the HyperX Level Awakening giveaway.',
  },
  privacy: {
    path: '/privacy',
    title: 'Privacy - HyperX Level Awakening',
    description:
      'Privacy disclosures for the HyperX Level Awakening site. Operated by Infinity Marketing Team, LLC on behalf of HyperX.',
  },
  terms: {
    path: '/terms',
    title: 'Terms - HyperX Level Awakening',
    description:
      'Terms of use for the HyperX Level Awakening site. Operated by Infinity Marketing Team, LLC on behalf of HyperX.',
  },
  cookies: {
    path: '/cookies',
    title: 'Cookie Policy - HyperX Level Awakening',
    description:
      'Inventory of the cookies and similar storage technologies used on the HyperX Level Awakening site.',
  },
  privacySettings: {
    path: '/privacy-settings',
    title: 'Privacy Settings - HyperX Level Awakening',
    description: 'Manage your analytics preferences for the HyperX Level Awakening site.',
  },
  admin: {
    path: '/admin',
    // Internal portal — gated by auth server-side. Not linked or indexed.
    title: 'Admin - HyperX Level Awakening',
    description: 'HyperX Level Awakening administration.',
  },
  notFound: {
    path: '/404',
    title: 'Page not found - HyperX Level Awakening',
    description: 'The page you are looking for does not exist.',
  },
} as const satisfies Record<string, PageMetaEntry>;
